import { render, staticRenderFns } from "./toggle-comparison-button.vue?vue&type=template&id=2c774cec&lang=pug"
import script from "./toggle-comparison-button.vue?vue&type=script&lang=coffee"
export * from "./toggle-comparison-button.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports